import React from 'react'
import LevelListContainer from '../../containers/Levels/List';
import LevelNavbarContainer from '../../containers/Levels/Navbar';

export default (props) => (
    <div>
        <LevelNavbarContainer {...props} title="Leerniveau's" />
        <LevelListContainer {...props} />
    </div>
)